export default __webpack_public_path__ + "static/media/Boing_BoldWEB.70501d1d.woff";